import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideEnvironmentInitializer,
} from '@angular/core';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { registerLocaleData } from '@angular/common';
import {
  HttpClientLoaderTranslation,
  InitService,
} from '@infodata-group/inf-commons';
import { environment } from '../environments/environment';
import localeFr from '@angular/common/locales/fr';
import { commonsProviders } from './config/commons.config';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';

registerLocaleData(localeFr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideRouter(appRoutes),
    provideEnvironmentInitializer(() =>
      inject(InitService).init(environment.env),
    ),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpClientLoaderTranslation,
        deps: [HttpClient],
      },
    }),
    commonsProviders,
    { provide: LOCALE_ID, useValue: 'fr' },
  ],
};
